<div class="container d-flex align-center justify-space-between" [ngClass]="{
    'padding-detail': listContractDetail,
    'container--modern': appearance === 'modern'
  }">
  <ng-content select="[headerFlag]"></ng-content>
  <ng-container *ngFor="let item of headerItems">
    <div class="container-label d-flex align-center" [ngClass]="{ 'text-center': textCenter }"
      [style.justify-content]="item.justify || 'space-around'" [style.flex]="item.flexSize"
      [style.text-align]="item.justify === 'flex-start' ? 'left' : item.justify === 'flex-end' ? 'right' : null">
      <span>
        {{ item.label }}
      </span>
    </div>
  </ng-container>
  <ng-content select="[button]"></ng-content>
</div>